var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 255,
    viewBox: "0 0 262 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_945_1866",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 262,
    height: 255
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.577 0.710449L0.0197754 0.710449L0.0197754 254.069L261.577 254.069V0.710449Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_945_1866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1919 23.7993L66.9507 8.18929C71.8843 4.62736 77.8139 2.71298 83.8965 2.71827L234.203 2.71827C236 2.71827 237.78 3.0727 239.441 3.76132C241.101 4.44995 242.61 5.45928 243.881 6.73169C245.152 8.0041 246.16 9.51466 246.848 11.1771C247.536 12.8396 247.89 14.6215 247.89 16.4209L247.89 144.212H254.307C255.703 144.212 257.042 144.767 258.03 145.756C259.017 146.744 259.571 148.084 259.571 149.482V204.845C259.577 206.384 259.194 207.9 258.457 209.251C257.721 210.603 256.656 211.746 255.36 212.575L196.25 252.076",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1919 23.7993L66.9507 8.18929C71.8843 4.62736 77.8139 2.71298 83.8965 2.71827L234.203 2.71827C236 2.71827 237.78 3.0727 239.441 3.76132C241.101 4.44995 242.61 5.45928 243.881 6.73169C245.152 8.0041 246.16 9.51466 246.848 11.1771C247.536 12.8396 247.89 14.6215 247.89 16.4209L247.89 144.212H254.307C255.703 144.212 257.042 144.767 258.03 145.756C259.017 146.744 259.571 148.084 259.571 149.482V204.845C259.577 206.384 259.194 207.9 258.457 209.251C257.721 210.603 256.656 211.746 255.36 212.575L196.25 252.076",
    stroke: "black",
    strokeWidth: 6.00074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.368 167.652H44.0387C43.6398 167.652 43.2573 167.493 42.9752 167.211C42.6931 166.929 42.5347 166.546 42.5347 166.146L42.5347 25.3051C42.5347 24.9057 42.6931 24.5227 42.9752 24.2404C43.2573 23.958 43.6398 23.7993 44.0387 23.7993L221.368 23.7993C221.767 23.7993 222.15 23.958 222.432 24.2404C222.714 24.5227 222.872 24.9057 222.872 25.3051L222.872 166.146C222.872 166.546 222.714 166.929 222.432 167.211C222.15 167.493 221.767 167.652 221.368 167.652Z",
    fill: "#F55007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.368 23.7993L44.0387 23.7993C43.2081 23.7993 42.5347 24.4735 42.5347 25.3051L42.5347 166.116C42.5347 166.948 43.2081 167.622 44.0387 167.622H221.368C222.199 167.622 222.872 166.948 222.872 166.116L222.872 25.3051C222.872 24.4735 222.199 23.7993 221.368 23.7993Z",
    stroke: "black",
    strokeWidth: 6.00074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.738 209.864H36.6688C36.2699 209.864 35.8873 209.706 35.6052 209.423C35.3232 209.141 35.1647 208.758 35.1647 208.359L35.1647 169.158C35.1577 168.958 35.1918 168.759 35.2649 168.574C35.338 168.388 35.4486 168.219 35.5897 168.078C35.7308 167.936 35.8994 167.826 36.085 167.753C36.2707 167.679 36.4694 167.645 36.6688 167.652L228.738 167.652C228.937 167.645 229.136 167.679 229.322 167.753C229.507 167.826 229.676 167.936 229.817 168.078C229.958 168.219 230.069 168.388 230.142 168.574C230.215 168.759 230.249 168.958 230.242 169.158V208.359C230.242 208.758 230.084 209.141 229.802 209.423C229.519 209.706 229.137 209.864 228.738 209.864Z",
    fill: "#5C26FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.738 167.652H36.6689C35.8382 167.652 35.1648 168.326 35.1648 169.158L35.1648 208.353C35.1648 209.185 35.8382 209.859 36.6689 209.859H228.738C229.569 209.859 230.242 209.185 230.242 208.353V169.158C230.242 168.326 229.569 167.652 228.738 167.652Z",
    stroke: "black",
    strokeWidth: 6.00074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.445 252.076L4.68233 252.076C3.9776 252.076 3.30174 251.796 2.80342 251.297C2.3051 250.798 2.02515 250.122 2.02515 249.416L35.1647 212.524C35.1647 211.819 35.4447 211.142 35.943 210.643C36.4413 210.145 37.1172 209.864 37.8219 209.864H227.585C228.29 209.864 228.966 210.145 229.464 210.643C229.962 211.142 230.242 211.819 230.242 212.524L197.103 249.416C197.103 250.122 196.823 250.798 196.324 251.297C195.826 251.796 195.15 252.076 194.445 252.076Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.445 252.076L4.68233 252.076C3.9776 252.076 3.30174 251.796 2.80342 251.297C2.3051 250.798 2.02515 250.122 2.02515 249.416L35.1647 212.524C35.1647 211.819 35.4447 211.142 35.943 210.643C36.4413 210.145 37.1172 209.864 37.8219 209.864H227.585C228.29 209.864 228.966 210.145 229.464 210.643C229.962 211.142 230.242 211.819 230.242 212.524L197.103 249.416C197.103 250.122 196.823 250.798 196.324 251.297C195.826 251.796 195.15 252.076 194.445 252.076Z",
    stroke: "black",
    strokeWidth: 6.00074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0129 188.733H67.5021",
    stroke: "black",
    strokeWidth: 6.00074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.459 188.733H186.524",
    stroke: "black",
    strokeWidth: 6.00074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.203 142.304H68.204C67.8091 142.292 67.4338 142.129 67.1544 141.85C66.875 141.57 66.7125 141.194 66.7 140.799L66.7 50.7025C66.7 50.3031 66.8584 49.9201 67.1405 49.6377C67.4225 49.3553 67.8051 49.1967 68.204 49.1967L197.203 49.1967C197.402 49.1897 197.601 49.2238 197.786 49.297C197.972 49.3702 198.141 49.4809 198.282 49.6221C198.423 49.7634 198.533 49.9322 198.607 50.1181C198.68 50.3039 198.714 50.5029 198.707 50.7025L198.707 140.799C198.707 141.198 198.548 141.581 198.266 141.863C197.984 142.146 197.602 142.304 197.203 142.304Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.203 49.1968L68.204 49.1968C67.3733 49.1968 66.7 49.8709 66.7 50.7026L66.7 140.794C66.7 141.625 67.3733 142.3 68.204 142.3H197.203C198.033 142.3 198.707 141.625 198.707 140.794L198.707 50.7026C198.707 49.8709 198.033 49.1968 197.203 49.1968Z",
    stroke: "black",
    strokeWidth: 6.00074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/Computer.bff2604e04755b8472024dac359310ba.svg";
export { ForwardRef as ReactComponent };